import { CanvasTexture, Group, MeshBasicMaterial } from 'three';
import { THREEObjectMaker } from '../../items/3d-objects/index.js';
import descs from '../../items/descs.js';
import { loadGLTF } from '../../items/3d-objects/gltf.js';
import { choose } from '../../utils.js';

const MAX_EV_LINES = 3;
const EV_FONT_SIZE = 80;
const CANVAS_SIZE = 500;
const ITEM_SPACING = 0.75;

const writeExVoto = (item, { exVoto }) => {
  const canvas = document.createElement('canvas');
  canvas.width = CANVAS_SIZE;
  canvas.height = CANVAS_SIZE;

  const context = canvas.getContext('2d');
  context.font = `${EV_FONT_SIZE}px Fraunces`;
  context.fillStyle = '#000';
  context.textAlign = 'center';
  context.scale(1, 2);

  const text = exVoto.toUpperCase();
  const { width } = context.measureText(text);
  console.info('[animita]', 'writing ex-voto', text, width);

  const numLines = Math.min(MAX_EV_LINES, Math.ceil(width / canvas.width));
  const words = text.split(' ');
  const wordsPerLine = Math.ceil(words.length / numLines);
  console.info('[animita]', 'writing', numLines, 'lines with', wordsPerLine, 'words per line');

  for (let line = 0; line < numLines; line++) {
    const lineWords = words.slice(line * wordsPerLine, line * wordsPerLine + wordsPerLine);
    console.info('[animita]', 'line', line, 'words', lineWords);

    context.fillText(
      lineWords.join(' '),
      CANVAS_SIZE / 2,
      EV_FONT_SIZE + line * EV_FONT_SIZE,
      canvas.width,
    );
  }

  const map = new CanvasTexture(canvas);
  const object = item.scene.getObjectByName('ex-voto-message');
  object.material = new MeshBasicMaterial({ map, transparent: true });
};

const scaleObject = (o) => {
  let maxRadius = 1;
  o.traverse((descendant) => {
    if (descendant.geometry) {
      descendant.geometry?.computeBoundingSphere();
      maxRadius = Math.max(maxRadius, descendant.geometry.boundingSphere.radius);
    }
  });

  const factor = 1 / maxRadius;
  console.info('[animita]', 'scaling', o.name, 'by', factor);

  o.scale.x = factor;
  o.scale.y = factor;
  o.scale.z = factor;
};

const createInventoryItems = async (G, { items }) => {
  console.info('[animita]', 'adding inventory items', items);

  const group = new Group();

  const objects = await Promise.all(items.map(async (n) => {
    const desc = descs.find(({ name }) => name === n);
    if (!desc?.gltf) {
      return null;
    }

    return loadGLTF(desc.gltf);
  }));

  objects
    .filter((o) => !!o)
    .forEach((o, index) => {
      scaleObject(o);
      o.position.x = ITEM_SPACING * (index % 3);
      o.position.z = ITEM_SPACING * (Math.floor(index / 3));

      group.add(o);
    });

  return group;
}

export const makeAnimita = async (G, config) => {
  console.info('[animita]', 'creating item');

  const make = THREEObjectMaker(G.google.InfoWindow);
  const side = choose([-1, 1]);
  const item = await make('/assets/items/animita/', {
    name: `Animita at ${config.position.lng()}`,
    cameraPosition: { x: (-side) * 3.7, y: 1.2, z: (-side) * 1.5 },
    lightPosition: { x: -5, y: 5, z: 5 },
    env: '/assets/img/limbo.env.jpg',
    onGround: true,
    big: true,
  });

  item.container.classList.add('gustavo-item--animita');
  // ensure the object is loaded before inserting
  await item.loadObject();

  writeExVoto(item, config);

  item.scene.add(await createInventoryItems(G, config));
  item.container.classList.add('gustavo-item--noninteractive');

  const actualPosition = {
    lat: config.position.lat() + side * (0.00006 + Math.random() * 0.00003),
    lng: config.position.lng() + 0.00005 + choose([-1, 1]) * (Math.random() * 0.00002),
  };

  item.insert(G.map, actualPosition);
  item.update();
  item.povUpdate();

  G.items.push(item);

  return actualPosition;
};
